<template>
  <div class="field-wrapper">
    <VField :label="$t('app.campaign.newPage.job')" :placeholder="$t('app.campaign.newPage.jobPlaceholder')" name="campaign-job" v-model="model" iconL="yuzu-icon yuzu-ai" />
  </div>
</template>

<style lang="scss" scoped>
.field-wrapper {
  width: 100%;
}
</style>

<script setup lang="ts">
import VField from '@/components/global/VField.vue';
import { CampaignCreation } from '@/stores/campaign';

const state = reactive<{
  job: string,
}>({
  job: "",
});

const props = defineProps<{
  modelValue: CampaignCreation,
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: CampaignCreation): void
  (e: 'valid', value: boolean): void
}>();

const model = computed({
  get: () => props.modelValue.campaign.job_title,
  set: (value: string) => {
    props.modelValue.campaign.job_title = value.trim();
    emit('valid', true);
    emit('update:modelValue', props.modelValue);
  }
});

onBeforeMount(() => {
  emit('valid', true);
})

</script>